/** @format */

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'amfe-flexible'
import 'vant/lib/index.less' // 引入vantui组件全部样式
import {
	Popup,
	NoticeBar,
	Toast,
	Field,
	Swipe,
	SwipeItem,
	NavBar,
	Tabbar,
	Uploader,
	Stepper,
	Icon,
	Empty,
	TabbarItem,
	Area,
	Picker,
	Checkbox,
	CheckboxGroup,
	RadioGroup,
	Radio,
	Dialog,
	ShareSheet,
	ActionSheet,
} from 'vant'

const Base64 = require('js-base64').Base64

Vue.use(ActionSheet)
Vue.use(ShareSheet)
Vue.use(Dialog)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Picker)
Vue.use(Area)
Vue.use(TabbarItem)
Vue.use(Tabbar)
Vue.use(Empty)
Vue.use(Icon)
Vue.use(Stepper)
Vue.use(Uploader)
Vue.use(NavBar)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(NoticeBar)
Vue.use(Popup)
Vue.use(Field)
Vue.use(Toast)
// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)
Vue.config.productionTip = false
Vue.prototype.router = router
new Vue({
	router,
	Base64,
	render: (h) => h(App),
}).$mount('#app')
